var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import * as _ from 'lodash';
import gql from 'graphql-tag';
import FilterList from './FilterList.vue';
import { whereQuery } from '@/services/sharedForm';
import { SILOS } from '@/queries/inventory';
import { BOLS_NO_LIMIT } from '@/queries/bols';
var shortList = ['Today', 'Yesterday', 'This Week', 'Last Week'];
var Inventory = /** @class */ (function (_super) {
    __extends(Inventory, _super);
    function Inventory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.silos = [];
        _this.siloData = null;
        _this.selectedSilo = null;
        _this.loading = false;
        _this.bols = [];
        _this.errMsg = false;
        _this.sortDir = 'desc';
        _this.showSiloData = false;
        _this.options = {
            showSilo: true,
            showLocation: true,
            showProduct: true,
            multiple: true,
            selectedSilo: [],
            selectedLocation: [],
            selectedProduct: [],
            notBolSilos: true,
            changeOptions: function () { return _this.getSilos(); }
        };
        _this.siloOptions = {
            showTimeframe: true,
            showLocation: true,
            showProduct: true,
            multiple: false,
            selectedLocation: {},
            selectedProduct: {},
            selectedTimeframe: 'This Week',
            getAlways: true,
            changeOptions: function () { return _this.getBols(); }
        };
        return _this;
    }
    Inventory.prototype.metaInfo = function () {
        return {
            title: 'Inventory'
        };
    };
    Object.defineProperty(Inventory.prototype, "selectSilo", {
        get: function () {
            return {};
        },
        set: function (newVal) {
            this.selectedSilo = __assign({}, newVal);
            this.showSiloData = true;
            this.bols = [];
            this.getBols();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Inventory.prototype, "filterInUse", {
        get: function () {
            return (this.options.selectedSilo && this.options.selectedSilo.length) ||
                (this.options.selectedProduct && this.options.selectedProduct.length) ||
                (this.options.selectedLocation && this.options.selectedLocation.length);
        },
        enumerable: true,
        configurable: true
    });
    Inventory.prototype.onSort = function (field, order) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sortDir = order;
                        return [4 /*yield*/, this.getBols()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Inventory.prototype.resetSilo = function () {
        this.selectedSilo = null;
        this.showSiloData = false;
    };
    Inventory.prototype.mounted = function () {
        this.getSilos();
    };
    Inventory.prototype.getSilos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ", ""], ["query ", ""])), SILOS),
                                variables: {
                                    where: whereQuery(this.options)
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 1:
                        res = _a.sent();
                        if (!res.data) {
                            throw new Error('No data');
                        }
                        this.silos = _.map(res.data.silos, function (silo) {
                            silo.available = silo.capacity - silo.current_weight;
                            return silo;
                        });
                        if (this.silos.length) {
                            this.calcSiloData();
                        }
                        else {
                            this.siloData = null;
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error loading silo data. Please try again.',
                            position: 'is-top',
                            type: 'is-warning'
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Inventory.prototype.calcSiloData = function () {
        var _this = this;
        this.siloData = [
            {
                name: 'Total Capacity',
                lbs: 0
            },
            {
                name: 'Current Weight',
                lbs: 0
            },
            {
                name: 'Available Weight',
                lbs: 0
            }
        ];
        this.silos.forEach(function (silo) {
            if (silo.capacity) {
                _this.siloData[0].lbs += silo.capacity;
            }
            if (silo.current_weight) {
                _this.siloData[1].lbs += silo.current_weight;
            }
        });
        this.siloData[2].lbs = this.siloData[0].lbs - this.siloData[1].lbs;
        this.siloData.forEach(function (data) {
            data.tons = data.lbs / 2000;
        });
    };
    Inventory.prototype.getBols = function () {
        return __awaiter(this, void 0, void 0, function () {
            var siloOptions, res, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.errMsg = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        siloOptions = _.cloneDeep(this.siloOptions);
                        siloOptions.selectedSilo = _.cloneDeep(this.selectedSilo);
                        return [4 /*yield*/, this.$apollo.query({
                                query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["query ", ""], ["query ", ""])), BOLS_NO_LIMIT),
                                variables: {
                                    where: whereQuery(siloOptions),
                                    sort: this.sortDir
                                },
                                fetchPolicy: 'no-cache'
                            })];
                    case 2:
                        res = _a.sent();
                        if (!res.data) {
                            throw new Error('No data');
                        }
                        this.bols = res.data.bols;
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.errMsg = true;
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error loading BOLs. Please try again.',
                            position: 'is-top',
                            type: 'is-warning'
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Inventory = __decorate([
        Component({
            name: 'inventory',
            components: {
                'filter-list': FilterList
            }
        })
    ], Inventory);
    return Inventory;
}(Vue));
export default Inventory;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/Inventory.vue
// module id = 787
// module chunks = 1